export const useInformationBarStore = defineStore('informationBar', () => {
	const visible = ref(true);

	function setVisible(state: boolean) {
		visible.value = state;
	}

	return {
		visible,
		setVisible,
	};
});
